<template>
    <span v-if="textOnly" :class="dataClass()">{{ weightDisplay() }}</span>

    <span v-else>

        <span class="font-weight-bold h3 text-success mb-0 align-middle" :class="dataClass()"><i
            class="fa-duotone fa-weight mr-2"></i>{{ weightDisplay() }}</span>

        <b-dropdown size="sm" :text="weightType" variant="light" class="mx-2 p-0 align-middle">
          <b-dropdown-item-button @click="setWeightType('dwt')">dwt</b-dropdown-item-button>
          <b-dropdown-item-button @click="setWeightType('oz')">oz</b-dropdown-item-button>
          <b-dropdown-item-button @click="setWeightType('lb')">lb</b-dropdown-item-button>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button @click="resetScaleConnection"><i
                class="fa-duotone fa-sync-alt fa-fw"></i>Refresh Scale</b-dropdown-item-button>
        </b-dropdown>

        <b-button v-if="captureButton" @click="captureWeight" :variant="isSettled ? 'success' : 'secondary'"
                  :disabled="!isSettled" size="sm" class="align-middle">Capture</b-button>

    </span>
</template>

<script>
import {round} from 'lodash';

export default {
    name: 'ScaleWeight',
    props: {
        captureButton: Boolean,
        textOnly: Boolean,
        stickyConnection: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scaleWeight: 'N/A',
            isSettled: false,
            weightType: 'dwt',
        };
    },
    mounted() {
        let vm = this;
        vm.scaleWeight = null;
        vm.isSettled = null;

        if (!vm.$qz.connected) {
            vm.$qz.connect().then(() => {
                console.log(String.fromCodePoint(0x2699) + '%c Scale plugin opened connection with QZ Tray', 'color:teal;');
                console.log(String.fromCodePoint(0x2699) + '%c Scale plugin opened connection with QZ Tray $scale', 'color:teal;');
                vm.$scale.connect((weight, settled) => {
                    if (weight !== this.scaleWeight) {
                        this.$emit('scale-weight', weight);
                        vm.scaleWeight = weight;
                    }
                    if (settled !== this.isSettled) {
                        this.$emit('scale-stable', settled);
                        vm.isSettled = settled;
                    }
                });
            });
        } else {
            console.log(String.fromCodePoint(0x2699) + '%c Scale plugin opened connection with QZ Tray $scale', 'color:teal;');
            vm.$scale.connect((weight, settled) => {
                if (weight !== this.scaleWeight) {
                    this.$emit('scale-weight', weight);
                    vm.scaleWeight = weight;
                }
                if (settled !== this.isSettled) {
                    this.$emit('scale-stable', settled);
                    vm.isSettled = settled;
                }
            });
        }
    },
    beforeDestroy() {
        let vm = this;
        vm.scaleWeight = null;
        vm.isSettled = null;

        if (!this.stickyConnection) {
            if (vm.$scale.connecting || this.$scale.disconnecting) {
                console.log(String.fromCodePoint(0x2699) + '%c Scale plugin connection was not closed with QZ Tray $scale because another connection is already opening or closing', 'color:yellow;');
            } else {
                console.log(String.fromCodePoint(0x2699) + '%c Scale plugin closing connection with QZ Tray $scale', 'color:orange;');
                vm.$scale.disconnect().finally(() => {
                    console.log(String.fromCodePoint(0x2699) + '%c Scale plugin closed connection with QZ Tray $scale', 'color:red;');
                });
            }
        } else if (!this.$scale.disconnecting || this.$scale.connected) {
            console.log(String.fromCodePoint(0x2699) + '%c Scale plugin set to sticky connection with QZ Tray $scale, keeping open.', 'color:yellow;');
        }
    },
    methods: {
        dataClass() {
            return [
                {'text-danger': !this.isSettled},
                {'text-success': this.isSettled},
            ];
        },
        weightDisplay() {
            if (!this.$qz.connected) {
                return 'ERR';
            }

            return this.convertWeightDisplay(this.scaleWeight);
        },
        captureWeight() {
            let vm = this;

            vm.$emit('capture', this.scaleWeight);
        },
        setWeightType(type) {
            this.weightType = type;
        },
        convertWeightDisplay(weight) {
            switch (this.weightType) {
                case 'oz':
                    return round(weight / 18.229, 2);
                case 'lb':
                    return round(weight / 292, 2);
                default:
                    return round(weight, 2);
            }
        },
        resetScaleConnection() {
            console.log(String.fromCodePoint(0x2699) + ' Scale plugin force-closed connection with QZ Tray $scale');
            this.$scale.disconnect()
                .then(() => {
                    console.log(String.fromCodePoint(0x2699) + ' Scale plugin re-opened connection with QZ Tray $scale');
                    this.$scale.connect((weight, settled) => {
                        if (weight !== this.scaleWeight) {
                            this.$emit('scale-weight', weight);
                            this.scaleWeight = weight;
                        }
                        if (settled !== this.isSettled) {
                            this.$emit('scale-stable', settled);
                            this.isSettled = settled;
                        }
                    });
                });
        },
    },
};
</script>

<style scoped>

</style>
